var twig = require("twig").twig,
    template = twig({"id":"7cc75c0700c5ebae5098030e1db8627e8f1d276db774385804c3a02e8a9e717460fbc271283e5be89b1d578e3e9e87689a598c2a464cf611c40e56fc9ae28177","data":[{"type":"raw","value":"<div class=\"grid\"></div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }